import { useEffect, useRef, useState } from "react";
import "../css/galerie.css";

export default function Galerie() {
  const [allMedia, setAllMedia] = useState([]);
  const [visibleCount, setVisibleCount] = useState(20);
  const loaderRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  // const [direction, setDirection] = useState(0);

  const goNext = () => {
  // setDirection(1);
  setSelectedIndex(prev => (prev + 1) % visibleMedia.length);
};

const goPrev = () => {
  // setDirection(-1);
  setSelectedIndex(prev => (prev - 1 + visibleMedia.length) % visibleMedia.length);
};

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const delta = touchStartX.current - touchEndX.current;

    const threshold = 50; // sensibilité

    if (Math.abs(delta) < threshold) return;

    if (delta > 0) {
      // swipe gauche → suivante
      goNext();
      // setSelectedIndex(prev =>
      //   (prev + 1) % visibleMedia.length
      // );
    } else {
      // swipe droite → précédente
      goPrev();
      // setSelectedIndex(prev =>
      //   (prev - 1 + visibleMedia.length) % visibleMedia.length
      // );
    }
  };

  // 🔹 Chargement initial
  useEffect(() => {
    fetch("/api/media/list")
      .then(res => res.json())
      .then(data => {
        data.sort((a, b) => new Date(a.uploadedAt) - new Date(b.uploadedAt));
        setAllMedia(data);
      });
  }, []);

  // 🔹 Scroll pour charger plus
  useEffect(() => {

    const handleScroll = () => {
      const scrollPosition = window.innerHeight + window.scrollY;
      const threshold = document.documentElement.scrollHeight - 200;

      if (scrollPosition >= threshold) {
        setVisibleCount(prev => {
          if (prev >= allMedia.length) return prev;
          return prev + 20;
        });
      }
    };

    // const handleScroll = () => {
    //   if (
    //     window.innerHeight + window.scrollY >=
    //     document.body.offsetHeight - 200
    //   ) {
    //     setVisibleCount(prev => {
    //       if (prev >= allMedia.length) return prev;
    //       return prev + 20;
    //     });
    //   }
    // };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [allMedia]);


  // 🔹 Liste visible uniquement
  const visibleMedia = allMedia.slice(0, visibleCount);

  useEffect(() => {
    const handleKey = (e) => {
      if (selectedIndex === null) return;

      if (e.key === "Escape") {
        setSelectedIndex(null);
      }

      if (e.key === "ArrowRight") {
        goNext();
        // setSelectedIndex(prev =>
        //   (prev + 1) % visibleMedia.length
        // );
      }

      if (e.key === "ArrowLeft") {
        goPrev();
        // setSelectedIndex(prev =>
        //   (prev - 1 + visibleMedia.length) % visibleMedia.length
        // );
      }
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [selectedIndex, visibleMedia, goNext, goPrev]);

  useEffect(() => {
    if (selectedIndex !== null) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (selectedIndex === null) return;

    const nextIndex = (selectedIndex + 1) % visibleMedia.length;
    const img = new Image();
    img.src = visibleMedia[nextIndex].url;
  }, [selectedIndex, visibleMedia]);

  return (
    <div id="gallery">
      <h1>Galerie</h1>
      <div className="grid">
        {visibleMedia.map((item, i) =>
          item.type === "photo" ? (
            <img
              key={i}
              src={item.url}
              loading="lazy"
              alt=""
              onClick={() => setSelectedIndex(i)} // ✅ CLICK
            />
          ) : (
            <video
              key={i}
              src={item.url}
              muted
              playsInline
              onClick={() => setSelectedIndex(i)} // ✅ CLICK
            />
          )
        )}
      </div>

      {selectedIndex !== null && (
        <div
          className="lightbox"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          onClick={(e) => {
            if (e.target.classList.contains("lightbox")) {
              setSelectedIndex(null);
            }
          }}
        >
          {/* Fermeture */}
          <div className="close" onClick={() => setSelectedIndex(null)}>
            ✕
          </div>

          {/* Navigation gauche */}
          <div
            className="nav left"
            onClick={() =>
              goPrev()
              // setSelectedIndex(
              //   (selectedIndex - 1 + visibleMedia.length) % visibleMedia.length
              // )
            }
          >
            ‹
          </div>


          {/* Média affiché */}
          <div className="lightbox-content">
            {visibleMedia[selectedIndex].type === "photo" ? (
              <img src={visibleMedia[selectedIndex].url} alt="" />
            ) : (
              <video
                src={visibleMedia[selectedIndex].url}
                controls
                autoPlay
              />
            )}
          </div>

          {/* Navigation droite */}
          <div
            className="nav right"
            onClick={() =>
              goNext()
              // setSelectedIndex(
              //   (selectedIndex + 1) % visibleMedia.length
              // )
            }
          >
            ›
          </div>

          {/* Aperçu avant / après */}
          <div className="preview prev">
            <img
              src={
                visibleMedia[
                  (selectedIndex - 1 + visibleMedia.length) %
                  visibleMedia.length
                ].url
              }
              alt=""
            />
          </div>

          <div className="preview next">
            <img
              src={
                visibleMedia[
                  (selectedIndex + 1) %
                  visibleMedia.length
                ].url
              }
              alt=""
            />
          </div>

        </div>
      )}
      {/* <div className="grid">
        {visibleMedia.map((item, i) =>
          item.type === "photo" ? (
            <img
              key={i}
              src={item.url}
              loading="lazy" // ✅ bonus natif
              alt=""
            />
          ) : (
            <video
              key={i}
              src={item.url}
              loading="lazy"
              muted
              playsInline
            />
          )
        )}
      </div> */}
      {visibleCount < allMedia.length && (
        <div style={{ textAlign: "center", padding: "1rem" }}>
          <p>Descendez pour charger plus de photos et vidéos</p>

          <button className="btn btn-primary load-more-btn" onClick={() => setVisibleCount(prev => prev + 20)}>
            Charger plus
          </button>
        </div>
      )}
      <div ref={loaderRef} style={{ height: "20px" }} />
    </div>
  );
}


// import { useEffect, useState } from "react";
// import "../css/galerie.css";

// export default function Galerie() {
//   const [media, setMedia] = useState([]);

//   useEffect(() => {
//     fetch("/api/media/list")
//       .then(res => res.json())
//       .then(data => setMedia(data));
//   }, []);

//   return (
//     <div id="gallery">
//       <h1>Galerie</h1>

//       <div className="grid">
//         {media.map((item, i) => (
//           item.type === "photo" ? (
//             <img key={i} src={item.url} />
//           ) : (
//             <video key={i} src={item.url} />
//           )
//         ))}
//       </div>
//     </div>
//   );
// }
